// extracted by mini-css-extract-plugin
module.exports =  {"main":"main__zakV6","mainContent":"mainContent__WwtxJ"};